$(document).ready(function(){

    $('#loginForm').validate({
        rules: {
            email: {
                required: true,
                email: true,
                validate_email: true,
            },
            password: {
                required: true,
                pwcheck: true
            }
        },
        messages: {
            email: {
                required: "Please enter the Email",
                validate_email: "Please enter a valid Email",
                email: "Please enter a valid Email"
            },
            password: {
                required: "Please enter the Password"
            }
        },
        errorElement: 'div',
        errorClass: 'validate-message',
        errorPlacement: function (error, element) {
            errorMsgPlacement(error, element);
        },
        highlight: function(element, errorClass, validClass) {
            $(element).addClass(errorClass).removeClass(validClass);
            $(element).closest('.form-group').addClass('invalid');
        },
        unhighlight: function(element, errorClass, validClass) {
            $(element).removeClass(errorClass).addClass(validClass);
            $(element).closest('.form-group').removeClass('invalid');
        },
        submitHandler: function(form) {
            $.ajax({
                url: appConfig.api_url + 'signin',
                type: 'POST',
                dataType: 'json',
                data: $(form).serialize(),
                beforeSend: function () {
                    showLoader();
                },
                success: function (data) {
                    hideLoader();
                    $(form)[0].reset();
                    successToaster(data.meta.message);
                    Cookies.set('access_token', data.data.accessToken);
                    Cookies.set('uuid', data.data.userDetail.uuid);
                    window.location.href = appConfig.url+ 'dashboard';
                },
                error: function (xhr) {
                    hideLoader();
                    showErrorAlertFromException(xhr);
                }
            });
            return false;
        }
    });
});